import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  toogleMenu,
  toggleMobileLeftMenu,
} from "../../../../actions/layoutAction";
import { withRouter } from "../../../../utils/utility";
import * as Icon from "react-feather";
import OctoIcon from "../../../../assets/icons/octo_icon.svg";
import SidebarToggle from "../admin/SidebarToggle";
import "../admin/adminSidebar.scss";
import {
  canStaffUpdateAvailability,
  STAFF_AVAILABILITY_LOCKED_MESSAGE,
  refreshStaffPortalPermissions,
} from "../../../../utils/authHelper";
import { notification } from "../../../../utils/utility";

const SIDEBAR_STORAGE_KEY = "meetocto.staffSidebarExpanded";

class StaffLeftMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      extended: true,
    };
  }

  componentDidMount() {
    let extended = true;

    try {
      const stored = window.localStorage.getItem(SIDEBAR_STORAGE_KEY);
      if (stored !== null) {
        extended = stored === "1";
      }
    } catch (error) {
      extended = true;
    }

    this.props.toogleMenu(extended);
    this.setState({ extended });

    refreshStaffPortalPermissions(() => {
      this.forceUpdate();
    });
  };

  toggleExtended = () => {
    this.setState((prevState) => {
      const extended = !prevState.extended;
      this.props.toogleMenu(extended);

      try {
        window.localStorage.setItem(SIDEBAR_STORAGE_KEY, extended ? "1" : "0");
      } catch (error) {
        // ignore storage failures
      }

      return { extended };
    });
  };

  closeMobileLeftMenu = () => {
    this.props.toggleMobileLeftMenu(null);
  };

  renderNavLabel = (text) => (
    <span className="admin-sidebar__nav-label">{text}</span>
  );

  renderLogoutBtn = (collapsed = false) => (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        this.props.userLogout();
      }}
      className={`admin-sidebar__logout ${
        collapsed ? "admin-sidebar__logout--collapsed" : ""
      }`}
      aria-label="Logout"
      data-sidebar-tooltip={collapsed ? "Logout" : undefined}
    >
      <Icon.LogOut size={18} />
      <span>Logout</span>
    </a>
  );

  renderScheduleNavItem = (pathname, extended, mobile = false) => {
    const isActive = pathname === "/staff/schedule";
    const className =
      "itemcomconsub staffNav schcdulcmenuicon " +
      (isActive ? "active" : "") +
      (!canStaffUpdateAvailability() ? " staff-nav--locked" : "");

    if (!canStaffUpdateAvailability()) {
      return (
        <span
          key="staff-schedule-locked"
          className={className}
          data-sidebar-tooltip={!extended && !mobile ? "Schedule" : undefined}
          role="button"
          tabIndex={0}
          onClick={() =>
            notification.warning(STAFF_AVAILABILITY_LOCKED_MESSAGE)
          }
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              notification.warning(STAFF_AVAILABILITY_LOCKED_MESSAGE);
            }
          }}
        >
          {mobile ? "Schedule" : this.renderNavLabel("Schedule")}
        </span>
      );
    }

    return (
      <Link
        key="staff-schedule"
        to="/staff/schedule"
        className={className}
        data-sidebar-tooltip={!extended && !mobile ? "Schedule" : undefined}
        onClick={this.closeMobileLeftMenu}
      >
        {mobile ? "Schedule" : this.renderNavLabel("Schedule")}
      </Link>
    );
  };

  renderDesktopNav = (pathname, extended) => (
    <div className="ul-listitemmenu">
      <Link
        to="/staff/dashboard"
        className={
          "itemcomconsub staffNav dashboardmenuicon " +
          (pathname === "/staff/dashboard" ? "active" : "")
        }
        data-sidebar-tooltip={!extended ? "My Dashboard" : undefined}
        onClick={this.closeMobileLeftMenu}
      >
        {this.renderNavLabel("My Dashboard")}
      </Link>

      {this.renderScheduleNavItem(pathname, extended)}

      <Link
        to="/staff/booking-history"
        className={
          "itemcomconsub staffNav eventcmenuicon " +
          (pathname === "/staff/booking-history" ? "active" : "")
        }
        data-sidebar-tooltip={!extended ? "My Booking History" : undefined}
        onClick={this.closeMobileLeftMenu}
      >
        {this.renderNavLabel("My Booking History")}
      </Link>

      <Link
        to="/staff/calendar-integration"
        className={
          "itemcomconsub staffNav calendarmenuicon " +
          (pathname === "/staff/calendar-integration" ? "active" : "")
        }
        data-sidebar-tooltip={!extended ? "Calendar Connections" : undefined}
        onClick={this.closeMobileLeftMenu}
      >
        {this.renderNavLabel("Calendar Connections")}
      </Link>
    </div>
  );

  renderMobileNav = (pathname) => (
    <div className="ul-listitemmenu">
      <Link
        to="/staff/dashboard"
        className={
          "itemcomconsub staffNav dashboardmenuicon " +
          (pathname === "/staff/dashboard" ? "active" : "")
        }
        onClick={this.closeMobileLeftMenu}
      >
        My Dashboard
      </Link>
      {this.renderScheduleNavItem(pathname, false, true)}
      <Link
        to="/staff/booking-history"
        className={
          "itemcomconsub staffNav eventcmenuicon " +
          (pathname === "/staff/booking-history" ? "active" : "")
        }
        onClick={this.closeMobileLeftMenu}
      >
        My Booking History
      </Link>
      <Link
        to="/staff/calendar-integration"
        className={
          "itemcomconsub staffNav calendarmenuicon " +
          (pathname === "/staff/calendar-integration" ? "active" : "")
        }
        onClick={this.closeMobileLeftMenu}
      >
        Calendar Connections
      </Link>
    </div>
  );

  render() {
    const { router, layout } = this.props;
    const { pathname } = router.location;
    const { extended } = this.state;

    return (
      <>
        <div
          className={`admin-sidebar-rail d-none d-md-block ${
            extended ? "admin-sidebar-rail--expanded" : "admin-sidebar-rail--collapsed"
          }`}
        >
          <aside
            id="staff-primary-sidebar"
            className={`sidemenu admin-sidebar ${
              extended ? "admin-sidebar--expanded" : "admin-sidebar--collapsed"
            }`}
          >
            <div className="admin-sidebar__inner">
              <div className="admin-sidebar__scroll">
                {this.renderDesktopNav(pathname, extended)}
              </div>
              <div className="admin-sidebar__footer">
                {this.renderLogoutBtn(!extended)}
              </div>
            </div>
          </aside>
          <SidebarToggle
            expanded={extended}
            onToggle={this.toggleExtended}
            sidebarId="staff-primary-sidebar"
          />
        </div>

        <aside
          className={`sidemenu admin-sidebar admin-sidebar--mobile d-md-none ${
            layout.leftMenuActiveClass || ""
          }`}
        >
          <div className="admin-sidebar__inner">
            <div
              className="mobile_left_topbar d-flex justify-content-between align-items-center"
              role="button"
            >
              <div className="imgs d-flex align-items-center">
                <img className="logo_icon" src={OctoIcon} alt="Octo Icon" />
              </div>
              <Icon.X size={23} onClick={() => this.props.toggleMobileLeftMenu(null)} />
            </div>
            <div className="admin-sidebar__scroll">
              {this.renderMobileNav(pathname)}
            </div>
            <div className="admin-sidebar__footer">{this.renderLogoutBtn(false)}</div>
          </div>
        </aside>
      </>
    );
  }
}

const actionMethods = {
  toogleMenu,
  toggleMobileLeftMenu,
};

const mapStateToProps = (state) => ({
  layout: state.layout,
});

export default connect(mapStateToProps, actionMethods)(withRouter(StaffLeftMenu));
